import { AxiosResponse } from 'axios';
import { supabase } from '@/lib/supabase';
import { asResponse } from '@/lib/supabase-helpers';

export type CoreWebVital = {
  value: number | null;
  displayValue: string | null;
  score: number | null;
};

export type PageSpeedResult = {
  url: string;
  scores: {
    performance: number;
    seo: number;
    accessibility: number;
  };
  coreWebVitals: {
    lcp: CoreWebVital;
    fid: CoreWebVital;
    cls: CoreWebVital;
    fcp: CoreWebVital;
    tbt: CoreWebVital;
    si: CoreWebVital;
  };
  strategy: string;
  error?: string;
};

const pageSpeedService = {
  async analyze(urls: string[], strategy: 'mobile' | 'desktop' = 'mobile'): Promise<AxiosResponse<PageSpeedResult[]>> {
    const { data, error } = await supabase.functions.invoke('pagespeed', {
      body: { urls, strategy },
    });

    if (error) throw error;
    return asResponse(data?.results ?? []);
  },
};

export default pageSpeedService;
